import React, { useState, useEffect } from 'react';
import { TextField, Grid, Checkbox, FormControlLabel } from '@mui/material';
import axios from '../../utils/axios.utils';

interface EditManufacturerFormProps {
  id: string;
  onSuccess: () => void;
  initialData?: any;
  showSnackbar?: (message: string, severity: 'success' | 'error') => void;
}

const EditManufacturerForm: React.FC<EditManufacturerFormProps> = ({ id, onSuccess, initialData, showSnackbar = () => {} }) => {
  const [formValues, setFormValues] = useState({
    mfr_name: '',
    mfr_enabled: false,
    mfr_enabled_liquid: false,
    mfr_enabled_recipe: false,
    mfr_enabled_seed: false,
    mfr_sync_set_id: '',
    active: true,
  });



  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | { name?: string; value: unknown }>) => {
    const { name, value, type } = e.target as HTMLInputElement;
    setFormValues(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  useEffect(() => {
    const fetchManufacturer = async () => {
      if (id && !initialData) {
        try {
          const response = await axios.get<any, any>(`api/admin/autotreat_mfr/mfrs/${id}/`, {
            headers: { 
              'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`
            }
          });
          
          setFormValues(prev => ({
            ...prev,
            ...response.data
          }));
        } catch (error: any) {
          console.error('Error fetching manufacturer:', error);
          const errorMessage = error?.response?.data?.message || 'Failed to load manufacturer data. Please try again.';
          showSnackbar(errorMessage, 'error');
        }
      } else if (initialData) {
        setFormValues(prev => ({
          ...prev,
          ...initialData
        }));
      }
    };

    fetchManufacturer();
  }, [id, initialData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const url = `api/admin/autotreat_mfr/mfrs/${id}/`;
      const method = id ? 'put' : 'post';
      
      const response = await axios[method]<any, any>(url, formValues, {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`
        }
      });
      
      showSnackbar('Manufacturer updated successfully', 'success');
      onSuccess();
    } catch (error: any) {
      console.error('Error updating manufacturer:', error);
      const errorMessage = error?.response?.data?.message || 
        (error instanceof Error ? error.message : 'Failed to update manufacturer. Please try again.');
      showSnackbar(errorMessage, 'error');
    }
  };

  return (
    <form id="dialog-form" onSubmit={handleSubmit}>
        <Grid container spacing={3} style={{ padding: '16px' }}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              name="mfr_name"
              label="MFR Name"
              fullWidth
              variant="outlined"
              value={formValues.mfr_name}
              onChange={handleInputChange}

            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="mfr_sync_set_id"
              label="MFR Sync Set ID"
              fullWidth
              variant="outlined"
              value={formValues.mfr_sync_set_id}
              onChange={handleInputChange}

            />
          </Grid>
          <Grid item xs={12} container spacing={2} sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {['mfr_enabled', 'mfr_enabled_liquid', 'mfr_enabled_recipe', 'mfr_enabled_seed', 'active'].map((field) => (
              <Grid item xs={6} key={field}>
                <FormControlLabel
                  control={
                    <Checkbox 
                      name={field} 
                      checked={formValues[field] || false} 
                      onChange={handleInputChange} 
                    />
                  }
                  label={field.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </form>
  );
};

export default EditManufacturerForm;
